
import XHeader from 'vux/src/components/x-header/index.vue'
import Selector from 'vux/src/components/selector/index.vue'

export default {
name: "search-score",
components: {
XHeader,Selector
},
mounted(){
var _this = this;
/*_this.currentterm = _this.termlist[0].key;
_this.$http.post('/searchapi/wechat/student/querySemester',{q:_this.$store.state.stu_num})
.then(function (response) {
var data = response.data;
if (data.code == "0"){
_this.currentterm = data.results.currentSem;
_this.semesters = data.results.semesters;
var tmpList = [];
for (var i = 0;i < _this.semesters.length; i++){
var tmpObj = _this.resetSem(_this.semesters[i]);
tmpList.push(tmpObj)
}
_this.termlist = tmpList;
_this.getScore(_this.currentterm);
}else {
_this.$msgbox('温馨提示',"当前没有可查询的学期");
}
})
.catch(function (error) {
that.$msgbox('温馨提示','系统内部异常，请联系管理员！');
})*/
},
data(){
return{
currentterm:'1',
semesters: [],
hasData: true,
termlist:[
{key: '1', value: '2018-2019学年第1学期'},
{key: '2', value: '2017-2018学年第2学期'},
{key: '3', value: '2017-2018学年第1学期'},
{key: '4', value: '2016-2017学年第2学期'}
],
courses:[
{class:'大学英语',score:'8',teacher:'刘老师',id:'1'},
{class:'java开发',score:'6',teacher:'刘老师',id:'2'},
{class:'C++课程设计',score:'10',teacher:'刘老师',id:'3'},
{class:'网页制作',score:'6',teacher:'刘老师',id:'4'},
{class:'高数',score:'7',teacher:'刘老师',id:'5'},
{class:'通信原理',score:'8',teacher:'刘老师',id:'6'},
],
iscurrent:true,
isevaluate:true,
}
},
methods:{
onChange (val) {
console.log(val)
},
resetSem(str){
return {
key: str,
value: str.split('_')[0]+"年第"+str.split('_')[1]+"学期"
}
},
gotoevalution(id){
var _this = this;
_this.$router.push({name:'gotoevaluation',params:{id:id}})
},
gotoevalutiondetail(id){
var _this = this;
_this.$router.push({name:'evaluationdetail',params:{id:id}})
}
}
}



// WEBPACK FOOTER //
// ./src/components/Onlineevaluation.vue